<div class="nes-mb-10">
  <div class="nes-flex nes-items-start nes-w-full nes-justify-between">
    <div class="nes-flex nes-gap-1">
      <h3 class="nes-h4">{{
        "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".TITLE" | translate
      }}</h3>
      <nes-tooltip
        [nesId]="'COMPOSE.CHOOSE_EXTRAS.ADDON.' + addon.identifier + '.TOOLTIP'"
      >
        {{
          "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".TOOLTIP"
            | translate
        }}
      </nes-tooltip>
    </div>
    <div *ngIf="addon.price">
      <nes-price
        [price]="addon.price / 100"
        size="xl"
        [trailingText]="'COMPOSE.CHOOSE_EXTRAS.PRICE_CATEGORY' | translate"
      >
      </nes-price>
    </div>
  </div>

  <div class="nes-flex nes-w-full nes-mb-3">
    @if (!addon.identifier.includes("UPDATE")) {
      {{
        "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".DESCRIPTION"
          | translate
      }}
    }
  </div>

  <div class="nes-flex">
    <nes-selectable
      #buttonRefTrue
      class="nes-mr-3 nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center"
      [id]="addon.identifier + '__ButtonTrue'"
      [nesId]="addon.identifier + '__ButtonTrue'"
      [label]="'COMPANY_DATA.TOGGLE_BUTTON.YES' | translate"
      name="option-yes"
      [checked]="addon.selected"
      (nesOnClick)="!routeLoading && selected.emit(!this.addon.selected)"
    >
      <div class="nes-py-4 nes-text-center">
        {{
          "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".BUTTON.CONFIRM"
            | translate
        }}
      </div>
    </nes-selectable>

    <nes-selectable
      #buttonRefFalse
      class="nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center"
      [id]="addon.identifier + '__ButtonFalse'"
      [nesId]="addon.identifier + '__ButtonFalse'"
      [label]="'COMPANY_DATA.TOGGLE_BUTTON.NO' | translate"
      name="option-no"
      [checked]="!addon.selected"
      (nesOnClick)="!routeLoading && selected.emit(!this.addon.selected)"
    >
      <div class="nes-py-4 nes-text-center">
        {{
          "COMPOSE.CHOOSE_EXTRAS.ADDON." + addon.identifier + ".BUTTON.DECLINE"
            | translate
        }}
      </div>
    </nes-selectable>
  </div>
</div>
